export default __webpack_public_path__ + "media/zurb/img/ecommerce/findability-56e22a95472274c81a2ed5b7216573e0.png";